import React, { useEffect, useState } from "react";
import { CheckCircle2, X } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const PecActivatedNotice = ({ onChanged }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    let active = true;
    api.get("/pec/activations").then(({ data }) => {
      if (!active) return;
      setItems(data.activated || []);
      if (data.updated) onChanged?.();
    }).catch(() => {});
    return () => { active = false; };
  }, [onChanged]);
  if (!items.length) return null;
  const dismiss = () => { api.post("/pec/activations/seen", null, { silent: true }).catch(() => {}); setItems([]); };
  return (
    <div role="status" className="flex items-start gap-3 rounded-xl border border-teal-500/50 bg-teal-500/10 p-4 animate-in fade-in slide-in-from-top-2" data-testid="pec-activated-notice">
      <CheckCircle2 className="w-5 h-5 text-teal-500 shrink-0 mt-0.5" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold" data-testid="pec-activated-title">{items.length === 1 ? "PEC attivata dal fornitore" : `${items.length} PEC attivate dal fornitore`}</p>
        <ul className="mt-1 text-sm text-muted-foreground space-y-0.5">
          {items.map((item) => <li key={item.id} className="[overflow-wrap:anywhere]" data-testid={`pec-activated-${item.id}`}>{item.casella} è attiva e pronta all’uso.</li>)}
        </ul>
      </div>
      <Button variant="ghost" size="icon" className="h-8 w-8 shrink-0" onClick={dismiss} aria-label="Ho capito, chiudi avviso" data-testid="pec-activated-dismiss"><X className="w-4 h-4" /></Button>
    </div>
  );
};
